import request from './request'
import * as http from '@/libs/http'

/**
 * 指定条件で予約可能な車両の一覧を返す
 *
 * @param {Number} shopid 店舗ID
 * @param {String} begin 予約開始日
 * @param {String} end 予約終了日
 * @param {Number} rid 検索から除外する予約番号
 * @param {Array} fields 追加フィールド
 * @returns {Response} レスポンスデータ
 */
export function getAvailableCars (shopid, begin, end, rid = 0, fields = []) {
  return request.get(`/shops/${shopid}/available/cars`, {
    params: {
      s: begin,
      e: end,
      rid: rid,
      fields: [
        'id',
        ...fields
      ]
    },
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
